import { Box, Button, Flex, Heading, Icon } from "@chakra-ui/react";
import { FC } from "react";
import { BsCheck2Circle } from "react-icons/bs";
import { useNavigate } from "react-router-dom";
import { successColor } from "../../utils/colors";

const PasswordDefinitionSuccessful: FC = () => {
  const navigate = useNavigate();

  return (
    <Box display="flex" width="100%" flexDirection="column" gap={8}>
      <Flex gap={2} direction="column">
        <svg viewBox="1.5 0 16 16" width="78px" height="78px">
          <Icon as={BsCheck2Circle} color={successColor} />
        </svg>
        <Heading as="h1">Senha definida com sucesso</Heading>
      </Flex>
      <Button
        type="button"
        alignSelf="flex-start"
        onClick={() => navigate("/")}
      >
        Voltar à Entrada
      </Button>
    </Box>
  );
};

export default PasswordDefinitionSuccessful;
